<template>
  <div class="wrapper">
    <h2 class="mainTitle">开发者使用提示及隐私政策</h2>
    <div class="content">
      <p>本政策仅适用于平安科技（深圳）有限公司及其旗下公司（以下简称“我们”）研发和运营的任意门SDK产品（以下简称“任意门”）。</p>
      <p>更新日期：2022年08月30日</p>
      <p>生效日期：2022年08月30日</p>
      <p>如果您有任何疑问、意见或建议，请通过以下联系方式与我们联系：</p>
      <p>电子邮箱：PUB_KJRYMSDKZX@pingan.com.cn</p>
      <p>地址： 深圳市南山区高新园嘉联支付大厦6F</p>
      <br />
      <h3>本政策将帮助您了解以下内容：</h3>
      <ol class="list">
        <li v-for="(item, index) in policyContent" :key="index">{{item}}</li>
      </ol>
      <p
        class="indent"
      >任意门产品和服务旨在为最终用户提供在开发者应用内便捷的跳转服务，使最终用户无需下载多个应用即可享受多种不同服务。开发者在其开发和/或运营的应用内集成任意门后，使用开发者应用的最终用户将可以在开发者应用内打开任意门功能，并通过任意门功能访问其他第三方主体提供的服务。在提供相关服务的过程中，我们可能会处理开发者应用的数据信息，其中可能包括开发者应用最终用户的个人信息。此开发者使用提示及隐私政策旨在帮助开发者及最终用户了解我们如何处理和保护最终用户的个人信息。</p>
      <p
        class="indent"
      >我们深知个人信息对您的重要性，并会尽全力保护您的个人信息安全。我们致力于维持用户对我们的信任，我们将恪守法律法规要求，按业界成熟的安全标准，采取安全保护措施来保护最终用户的个人信息。</p>
      <p class="indent">请开发者和最终用户在使用我们的产品或服务前，仔细阅读并了解本开发者使用提示及隐私政策。</p>
      <br />
      <h3>定义：</h3>
      <h3>开发者使用提示及个人信息保护政策的相关定义如下：</h3>
      <ol class="list">
        <li v-for="(item, index) in definitionContent" :key="index">{{item}}</li>
      </ol>
      <h3>开发者使用提示：</h3>
      <ol class="list">
        <li v-for="(item, index) in usageContent" :key="index" v-html="item"></li>
      </ol>
      <h3>请在使用我们的产品（或服务）前，仔细阅读并了解本《隐私政策》。</h3>
      <h3>一、我们如何收集和使用您的个人信息</h3>
      <h3>（一）保障任意门和服务的正常运行</h3>
      <p>当您使用任意门时，为保障您正常使用我们的服务，维护我们服务的正常运行，改进及优化您的服务体验，我们会获取您的设备信息，<span class="emphasis">包括设备型号、操作系统版本、网络信息（读取WIFI状态）、网络请求信息，这类信息是为提供服务必须收集的基础信息。</span></p>
      <p><span class="emphasis">请注意，单独的设备信息是无法识别特定自然人身份的信息。</span>如果我们将这类非个人信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类非个人信息将被视为个人信息，除法律法规另有规定外，我们会将该类个人信息做匿名化、去标识化处理，否则，这些信息在结合使用期间将按照本隐私政策处理与保护。</p>
      <h3>（二）参与各类任意门自营活动</h3>
      <p>
        任意门可能会不时推出问卷调查、抽奖等自营活动，此类线上活动可能需要您提供您的<span class="emphasis">姓名、电话、电子邮箱、家庭地址信息（如任意门需在特定的自营活动中收集额外的个人信息，我们将单独提示并征得您的同意，除非该活动存在单独的隐私保护政策，额外收集的个人信息将同样适用本隐私政策的规定），这些信息将作为您参与活动、接收奖品等的凭证，</span>拒绝提供这些信息仅会使您无法参与特定活动，但不影响您正常使用任意门的其他功能。
      </p>
      <h3>（三）个性化推荐服务</h3>
      <p class="emphasis">在您使用任意门的过程中，我们可能会收集您访问、点击任意门内各类活动的情况用于分析并向您推荐您可能感兴趣的内容。您可以在任意门提供的设置功能中，关闭个性化推荐服务，在您关闭该服务后，我们不会再向您推送基于您的个人信息的内容。</p>
      <h3>（四）第三方信息收集提示</h3>
      <p class="emphasis">任意门旨在为最终用户提供跨平台、跨运营主体间便捷的跳转服务，最终用户可以通过任意门跳转至第三方页面以获取第三方主体提供的活动、产品或服务，跳转后，最终用户所提交的信息均由第三方主体直接获取，最终用户应在提供个人信息前仔细阅读第三方主体的个人信息保护政策，任意门不会收集、使用、存储或截留最终用户直接向第三方主体提供的信息。</p>
      <p>例如，最终用户可通过任意门跳转至第三方主体的线上小游戏、线上问卷调查、产品购买、开通账户等界面，在参与上述活动中，根据活动类型，最终用户可能可以自行上传个人照片作为小游戏头像、通过问卷反馈个人信息、提交问题截图、上传个人证件照以办理账户、填写个人地址和地理位置信息以接受送货服务、上传照片至朋友圈等，该类信息将由最终用户向第三方主体直接提供。<span class="emphasis">任意门提示，最终用户应仔细阅读第三方主体的个人信息保护政策，审慎甄别个人信息等方面的安全风险，如认为存在安全风险的，请不要同意相关个人信息保护政策或提供个人信息。</span></p>
      <p>您可点击查看<a href="https://maam-res.pingan.com.cn/web/PaDailyNews/index.html#/article/A00000013" style="text-decoration: underline;">第三方列表</a>， 进一步了解涉及到的第三方运营主体、收集的个人信息类型等具体情况。</p>
      <h3>（五）系统权限说明</h3>
      <ol class="list">
        <li>
          <span class="emphasis">重力感应设备权限：</span>当您使用与重力感应设备（使用传感器）有关的业务功能时需要获取您的行为指令，以便为您提供相关服务，例如部分线上小游戏可能存在重力感应调整方向的功能。若您不开启此权限，您可以使用任意门SDK提供的其他服务，但是您可能无法使用与重力感应设备（使用传感器）有关的业务功能。
        </li>
        <li>
          <span class="emphasis">摄像头权限：</span>当您使用任意门SDK上投放的产品或服务，例如使用到在线客服功能时需要上传照片描述您的问题， 我们会向您申请获取此权限，以便您进行实时拍摄并上传图片或视频内容。若您选择不开启此权限，您将无法使用图片或视频拍摄相关的功能，但不影响您使用其他服务。
        </li>
        <li>
          <span class="emphasis">相册权限：</span>当您在使用任意门SDK上投放的业务产品或服务并通过任意门上传的您的头像、分享的照片时，我们会向您申请获取此权限，以便您上传设备中的图片或视频。若您选择不开启此权限，您将无法使用图片或视频上传相关的功能，但不影响您使用其他服务。
        </li>
        <li>
          <span class="emphasis">位置信息权限：</span>当您使用与位置有关的服务时，我们可能会记录您设备所在的位置信息，以便为您提供相关服务。举例如：附近的银行网点、附近的加油站等。
          <p>在您使用服务时，我们可能会通过GPS等途径获取您的地理位置信息；您或其他用户在使用服务时提供的信息中可能包含您所在地理位置信息，例如您提供的帐号信息中可能包含的您所在地区信息，您或其他人共享的照片包含的地理标记信息。我们会向您申请获取此权限，以便获取您所在的地理位置，识别欺诈风险。若您选择不开启此权限，您将无法使用基于位置信息相关的特定功能，但不影响您使用其他服务。</p>
        </li>
        <li>
          <span class="emphasis">网络权限：</span>当您运行任意门SDK时，我们会向您申请获取此权限，用于与服务端进行通讯。若您选择不开启此权限，任意门SDK所有功能无法使用。
          <p>上述内容需要您在您的设备中同意向我们开启访问权限，以实现这些功能所涉及的信息收集和使用。您确认并同意开启这些权限，我们才会在您使用特定业务功能时，收集和使用为了正常运行该业务功能所必需的信息，并在您停止该业务功能的使用后，我们将会停止您的个人信息收集的行为；您也可以遵循您所使用设备的操作系统指示变更或者取消这些授权，我们也将不再继续收集和使用您的这些信息，也无法为您提供上述与这些授权所对应的功能，但这不会对您使用任意门SDK其他服务产生影响。</p>
        </li>
        <li>
          <span class="emphasis">添加桌面权限：</span>当您在使用任意门sdk时，如您需要将当前使用的业务在桌面添加一个快捷方式，则需要申请此权限。如选择不开启此权限，不会影响业务的正常使用，但无法添加桌面快捷方式。
        </li>
      </ol>
      <h3>（六）依法豁免征得同意收集和使用的个人信息</h3>
      <p>请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：</p>
      <ol class="list">
        <li v-for="(item, index) in exemptionContent" :key="index">{{item}}</li>
      </ol>

      <br />
      <h3>二、我们如何共享、转让、公开披露您的个人信息</h3>
      <h3>（一）共享</h3>
      <p>我们不会与任何公司、组织和个人共享您的个人信息，但以下情况除外：</p>
      <ol class="list">
        <li>在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他方共享您的个人信息。</li>
        <li>我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</li>
        <li>
          为了更好地为您提供产品与服务，履行我们的社会责任与法定义务，同时实现我们的商业价值，我们可能会与关联公司共享您的个人信息，用于基本业务功能。关联公司所涉行业包括：保险、银行、信托、证券、资产管理、财富管理、基金管理、融资租赁、普惠金融、健康医疗等。
          <p style="padding-left: 1em;">A.	<span class="emphasis">基本业务功能系为向您提供产品与服务所必需，或是为防范风险、保障安全、实现合规所必要。请您授权我们进行该等共享，否则我们难以为您提供安全的、统一的服务。</span>具体而言，我们的基本业务功能包括：</p>
          <p style="padding-left: 2em;">•	为您提供产品与服务：我们可能共享您必要的个人信息，以便联合向您提供您所要求的产品或服务。例如，任意门可能会与其他关联公司联合举办线上活动，任意门可能需要向关联公司提供必要的个人信息以满足您参与活动的服务需求。</p>
          <p style="padding-left: 2em;">•	法定义务：我们可能共享您必要的个人信息，履行我们在反洗钱、反恐怖融资、投资者适当性管理、监管报送等方面的法定义务。</p>
          <p style="padding-left: 1em;">B.	<span class="emphasis">扩展业务功能是为了进一步提升您的用户体验，或是为了向您提供更为智能化、个性化的服务。我们会在开启扩展业务功能之前单独征求您的同意，您可以自主选择是否授权我们进行该等共享，并且方便地管理授权的状态包括取消授权。如果您拒绝授权扩展业务功能，并不会影响您对基本业务功能的使用。</span>具体而言，我们的基本业务功能包括：</p>
          <p style="padding-left: 2em;">•	内容推荐：我们可能共享您访问、点击任意门内各类活动的情况，从而向您推荐您可能感兴趣的资讯、活动或其他内容，便于您了解相关信息。</p>
          <p style="padding-left: 2em;">•	营销推广：我们可能共享您访问、点击任意门内各类活动的情况，从而向您发送您可能感兴趣的广告、营销活动通知、商业性信息等内容，推广我们的产品或服务。</p>
          <p style="padding-left: 2em;">•	SDK共享：为了更好地向您提供产品与服务，我们会通过其他的软件开发工具包（SDK）、应用程序接口（API）等方式进行必要的数据共享。我们会对接入的SDK、API进行安全监测，并要求其采取数据保护措施。</p>
          <p style="padding-left: 2em;">您可点击查看<a href="https://maam-res.pingan.com.cn/web/PaDailyNews/index.html#/article/A00000012" style="text-decoration: underline;">JS SDK列表</a>，进一步了解SDK的名称、运营方、使用目的、个人信息的类型等具体情况。</p>
          <p style="padding-left: 1em;">C.	在共享您的个人信息之前以及共享的过程中，我们将充分评估该等共享的合法性、正当性、必要性，并采用适当的管理措施与技术措施，以保障您的个人信息安全。关联公司如果想要改变本隐私政策声明的个人信息使用目的，将再次征求您的授权同意。</p>
          <p style="padding-left: 1em;">D.	我们的关联公司包括但不限于：中国平安人寿保险股份有限公司、中国平安财产保险股份有限公司、 平安养老保险股份有限公司、平安健康保险股份有限公司、平安银行股份有限公司、平安资产管理有限责任公司、平安信托有限责任公司、平安证券有限责任公司、平安期货有限公司、平安基金管理有限公司、平安不动产有限公司、平安国际融资租赁有限公司、上海陆家嘴国际金融资产交易市场股份有限公司（陆金所）、平安健康互联网股份有限公司、深圳壹账通智能科技有限公司、平安医疗健康管理股份有限公司、平安壹钱包电子商务有限公司、平安城市建设科技（深圳）有限公司、深圳平安综合金融服务有限公司、平安国际智慧城市科技股份有限公司、深圳前海金融资产交易所有限公司、重庆金融资产交易所有限责任公司、陆金所控股有限公司、平安保险（集团）股份有限公司、北京车之家信息技术有限公司。</p>
        </li>
      </ol>
      <h3>（二）转让</h3>
      <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
      <ol class="list">
        <li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息；</li>
        <li>在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受此隐私政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</li>
      </ol>
      <h3>（三）公开披露</h3>
      <p>您通过任意门所跳转的第三方主体平台可能存在信息分享功能，当您在第三方活动使用相关功能时，您可以与您的好友及其他用户分享您的相关信息，例如，您可能可以通过第三方平台公开分享您的照片和视频。请注意，您公开分享的的信息中可能包含您的个人信息。请您谨慎考虑披露您的个人信息。您分享的信息会存储在相关业务方的服务器中，任意门不会获取您的此类信息。</p>
      <p>我们仅会在以下情况下，公开披露您的个人信息：</p>
      <ol class="list">
        <li>获得您明确同意后；</li>
        <li>基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</li>
      </ol>
      <br />
      <h3>三、我们如何存储个人信息</h3>
      <p>（一）存储地点</p>
      <p>
        <span class="emphasis">我们依照法律法规的规定，将在中国大陆地区运营过程中收集和产生的您的个人信息存储于中华大陆境内。</span>目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循相关国家规定或者征求您的同意。
      </p>
      <p>（二）存储期限</p>
      <p>一般而言，我们仅为实现目的所必需的最短时间保留您的个人信息。但在下列情况下，我们有可能因需符合法律要求，更改个人信息的存储时间：</p>
      <p>1）为遵守适用的法律法规等有关规定；</p>
      <p>2）为遵守法院判决、裁定或其他法律程序的规定；</p>
      <p>3）为遵守相关政府机关或法定授权组织的要求；</p>
      <p>4）我们有理由确信需要遵守法律法规等有关规定；</p>
      <p>5）为执行相关服务协议或本政策、维护社会公共利益，为保护我们的客户、我们或我们的关联公司、其他用户或雇员的人身财产安全或其他合法权益所合理必需的用途；</p>
      <p>6）当我们的产品或服务发生停止运营的情形时，我们将采取，例如推送通知、公告等形式通知您，并在合理的期限内删除或匿名化处理您的个人信息。</p>
      <br />
      <h3>四、我们如何保护您的个人信息</h3>
      <p>（一）我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。例如，在您的浏览器与“服务”之间交换数据（如信用卡信息）时受 SSL 加密保护；我们同时对任意门SDK网站提供 https 安全浏览方式；我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击；我们会部署访问控制机制，确保只有授权人员才可访问个人信息；以及我们会举办安全和隐私保护培训课程，加强员工对于保护个人信息重要性的认识。</p>
      <p>（二）我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
      <p>（三）互联网并非绝对安全的环境，而且电子邮件、即时通讯、及与其他平台用户的交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</p>
      <p>（四）我们将定期更新并公开安全风险、个人信息安全影响评估等报告的有关内容。您可通过平安科技平台消息通知获得。</p>
      <p>（五）互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
      <p>（六）在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。</p>
      <p>同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
      <br />
      <h3>五、您如何管理自己的信息</h3>
      <p>（一）在使用我们服务的过程中，您可以行使访问、修改、删除、撤回同意、改变授权范围等个人信息权利。<span class="emphasis">请您理解，任意门并不直接面对最终用户，向开发者提出个人信息请求或设置开发者应用的权限功能可能是最终用户行使个人信息权利更为便捷的形式，</span>但最终用户仍可以发送电子邮件至如下地址以直接向我们行使个人信息权利：PUB_KJRYMSDKZX@pingan.com.cn。</p>
      <p>（二）在您访问、修改和删除相关信息时，我们可能会要求您进行身份验证，以保障帐号的安全。</p>
      <p>（三）对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。</p>
      <p>（四）在以下情形中，我们可能无法响应您的请求：</p>
      <p>1) 与个人信息控制者履行法律法规规定的义务相关的；</p>
      <p>2) 与国家安全、国防安全直接相关的；</p>
      <p>3) 与公共安全、公共卫生、重大公共利益直接相关的；</p>
      <p>4) 与犯罪侦查、起诉、审判和执行判决等直接相关的；</p>
      <p>5) 个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
      <p>6) 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
      <p>7) 响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
      <p>8) 涉及商业秘密的。</p>
      <br />
      <h3>六、我们如何处理未成年人的个人信息</h3>
      <p class="list emphasis">任意门仅针对成年用户，未成年用户请勿直接使用任意门，如您发现我们收集了未成年人的个人信息的，请及时与我们联系，我们将及时删除或匿名化处理相关信息。</p>
      <br />
      <h3>七、本政策如何更新</h3>
      <p>随着任意门功能的迭代变化，本政策可能更新。未经您明确同意，我们不会削减您按照本隐私政策所应享有的权利。我们会在本页面上发布对本政策所做的任何变更。</p>
      <br />
      <h3>八、如何联系我们</h3>
      <ol class="list">
        <li>如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系：发送邮件至邮箱地址：PUB_KJRYMSDKZX@pingan.com.cn。</li>
        <li>一般情况下，我们将在15个工作日内回复。</li>
      </ol>
      <div class="emphasis company">平安科技（深圳）有限公司</div>
    </div>
  </div>
</template>

<script>
import RymApp from "@/utils/native";
export default {
  name: "Privacy",
  data() {
    return {
      policyContent: [
        "我们如何收集和使用您的个人信息",
        "我们如何共享、转让、公开披露您的个人信息",
        "我们如何存储个人信息",
        "我们如何保护您的个人信息",
        "您如何管理自己的信息",
        "我们如何处理未成年人的个人信息",
        "本政策如何更新",
        "如何联系我们"
      ],
      definitionContent: [
        "个人信息：指以电子或者其他方式记录的与已识别或者可识别的自然人相关的各种信息。",
        "开发者：指在自身产品或服务中集成任意门的公司、组织、个人或其他主体。",
        "开发者应用：开发者开发和/或运营的、集成了任意门产品的应用，包括但不限于APP、网页、小程序、公众号等。",
        "最终用户：指开发者应用所面向的终端自然人用户。"
      ],
      usageContent: [
        "开发者应遵守个人信息有关的所有可适用法律、政策和法规，保护最终用户个人信息安全。<span class='emphasis'>开发者应当通过隐私政策、个人信息保护声明等形式向最终用户说明任意门的信息收集情况并征得最终用户的同意，否则开发者不得使用任意门或应立即关闭任意门功能。</span>",
        "开发者应向最终用户提供易于操作的访问、更正、删除其个人信息，撤销或更改其授权同意、注销其个人账号、个人信息迁移等个人信息权利实现机制。最终用户的个人信息处理请求涉及任意门的，我们将在确认最终用户身份后配合开发者完成个人信息处理。",
        "任意门仅针对成年人。如开发者应用面向未成年人的，开发者应与我们联系，同时，开发者应建立健全未成年人个人信息保护机制，向最终用户列明未成年人个人信息处理规则，未经未成年人的父母或监护人同意的，不得处理其个人信息。",
        "如我们发现开发者存在违法违规处理个人信息的风险，我们将有权采取关停服务、单方面响应最终用户个人信息处理请求等措施以保障最终用户的个人信息权益。",
        // "海外开发者（含港澳台地区）应在满足当地可适用的法律法规的前提下使用任意门，如发现本政策内容与可适用的法律法规规定不符的，请勿直接使用任意门。海外开发者可以与我们联系，并配合我们推出针对特定地区的个人信息保护政策。"
      ],
      exemptionContent: [
        "为订立、履行个人作为一方当事人的合同所必需，或者按照依法制定的劳动规章制度和依法签订的集体合同实施人力资源管理所必需；",
        "为履行法定职责或者法定义务所必需；",
        "为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需；",
        "为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息；",
        "依据法律规定，在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息；",
        "法律、行政法规规定的其他情形。"
      ]
    };
  },
  created() {
    RymApp.track("隐私协议", "首页曝光");
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.wrapper {
  overflow-x: hidden;
  font-size: 14px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  flex-direction: column;
  padding: 20px;
  line-height: 2em;
  color: #333;
  text-align: justify;
  word-break: break-all;
  .mainTitle {
    font-size: 18px;
    text-align: center;
  }
  h3 {
    margin: 5px 0;
    font-size: 15px;
  }
  p.indent {
    text-indent: 2em;
  }
  .content {
    margin-top: 20px;
    .list {
      list-style: decimal;
      list-style-position: inside;
      padding: 5px 0;
    }
    ::v-deep .emphasis {
      font-weight: bold;
    }
    .company {
      text-align: right;
    }
  }
}
</style>
